import React from "react";
import Layout from "../components/BlogParts/Layout";
import BlogIndex from "../components/BlogParts/BlogIndex";
import {graphql, useStaticQuery} from "gatsby";

const FourthPage = () => {
    const data = useStaticQuery(pageQuery)
    return (
        <Layout children={
            <BlogIndex props={ data }/>
        }/>
    )
}

export default FourthPage

export const pageQuery = graphql`
  query {
      allMdx(filter: {frontmatter: {published: {eq: "yes"}}}, sort: {fields: frontmatter___date, order: DESC}) {
        edges {
          node {
            id
            frontmatter {
              authors
              category
              date(formatString: "l", locale:"cs")
              lang
              modified(formatString: "l", locale:"cs")
              summary
              tags
              title
              published
            }
            fields {
              slug
            }
          }
        }
      }
  }
`